export const LoadBoardTypesEnum = {
    SHIP_CARS: 1,
    SUPER_DISPATCH: 2
};

export const LoadBoardTypesList = [
    { id: LoadBoardTypesEnum.SHIP_CARS, name: "ShipCars" },
    { id: LoadBoardTypesEnum.SUPER_DISPATCH, name: "SuperDispatch" }
];

// Super Dispatch shows our load id as the order number; its loadBoardId is an internal order guid nobody sees.
export const getLoadBoardReference = (load) =>
    load?.loadBoard == LoadBoardTypesEnum.SUPER_DISPATCH && load?.loadBoardId?.trim()
        ? `${load.id}`
        : load?.loadBoardId;
